import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { keyframes } from '@mui/system';
import HeroSlider from './HeroSlider';

/* ------------------ Animation ------------------ */
const pulse = keyframes`
  0%, 100% { opacity: 0.2; }
  50% { opacity: 0.4; }
`;

const HeroSection = () => {
  /* ------------------ TAWK OPEN HANDLER ------------------ */
  const openTawkChat = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth',
    });
    if (window.Tawk_API && window.Tawk_API.maximize) {
      window.Tawk_API.maximize();
      return;
    }
    setTimeout(() => {
      if (window.Tawk_API && window.Tawk_API.maximize) {
        window.Tawk_API.maximize();
      }
    }, 600);
  };

  return (
    <Box
      sx={{
        background:
          'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #2a2a2a 100%)',
        color: 'white',
        py: { xs: 8, md: 12 },
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <svg style={{ position: 'absolute', width: 0, height: 0 }}>
        <defs>
          <filter id="chalk">
            <feTurbulence baseFrequency="0.9" numOctaves="4" />
            <feDisplacementMap in="SourceGraphic" scale="1" />
          </filter>
        </defs>
      </svg>

      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 6,
            flexDirection: { xs: 'column', md: 'row' },
          }}
        >
          {/* ================= LEFT ================= */}
          <Box sx={{ flex: 1 }}>
            <Typography
              sx={{
                fontSize: { xs: '2.6rem', md: '3.6rem' },
                fontWeight: 800,
                lineHeight: 1.2,
                mb: 3,
              }}
            >
              Find experienced managers in{' '}
              <Box
                component="span"
                sx={{
                  color: '#10b981',
                  position: 'relative',
                  display: 'inline-block',
                }}
              >
                minutes!
                <Box
                  component="svg"
                  viewBox="0 0 200 16"
                  sx={{
                    position: 'absolute',
                    bottom: -6,
                    left: 0,
                    width: '100%',
                  }}
                >
                  <path
                    d="M8,10 L192,8"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                    fill="none"
                    style={{ filter: 'url(#chalk)' }}
                  />
                </Box>
              </Box>
            </Typography>

            <Typography
              sx={{
                color: '#d1fae5',
                fontSize: '1.15rem',
                mb: 4,
                maxWidth: 520,
              }}
            >
              Experience the power of open web to reduce prospecting time
              to minutes from hours
            </Typography>

            {/* ===== CTA BUTTON ===== */}
            <Button
              onClick={openTawkChat}
              variant="contained"
              sx={{
                background: 'linear-gradient(135deg, #10b981, #059669)',
                px: 4,
                py: 1.6,
                fontSize: '1rem',
                fontWeight: 600,
                borderRadius: 2,
                mb: 4,
                textTransform: 'none',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: '0 10px 25px rgba(16,185,129,.3)',
                },
              }}
            >
              Book a Demo
            </Button>

            <Box sx={{ display: 'flex', gap: 3 }}>
              {['No credit card required', 'Setup in minutes'].map((text) => (
                <Box
                  key={text}
                  sx={{
                    display: 'flex',
                    gap: 1,
                    alignItems: 'center',
                  }}
                >
                  <CheckIcon sx={{ fontSize: 16, color: '#d1fae5' }} />
                  <Typography
                    sx={{ fontSize: '.85rem', color: '#d1fae5' }}
                  >
                    {text}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>

          {/* ================= RIGHT ================= */}
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              justifyContent: { xs: 'center', md: 'flex-end' },
              position: 'relative',
            }}
          >
            <Box sx={{ width: 450, maxWidth: '100%', position: 'relative' }}>
              <HeroSlider />

              {/* Decorative blobs */}
              <Box
                sx={{
                  position: 'absolute',
                  top: -20,
                  right: -20,
                  width: 80,
                  height: 80,
                  bgcolor: '#10b981',
                  borderRadius: '50%',
                  opacity: 0.2,
                  animation: `${pulse} 2s infinite`,
                }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  bottom: -24,
                  left: -24,
                  width: 60,
                  height: 60,
                  bgcolor: '#3b82f6',
                  borderRadius: '50%',
                  opacity: 0.2,
                  animation: `${pulse} 2s infinite`,
                  animationDelay: '1s',
                }}
              />
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default HeroSection;